import { Component, OnInit } from '@angular/core';
import { GlobalMessageComponent } from '@spartacus/storefront';

@Component({
    selector: 'app-uig-global-message',
    templateUrl: './uig-global-message.component.html',
    styleUrls: ['./uig-global-message.component.scss'],
    standalone: false
})
export class UigGlobalMessageComponent extends GlobalMessageComponent {

}
